import {useCallback} from 'react'

import {useQueryParamState} from '../../../hooks/routes'

import {DEFAULT_PAGE, PAGE_QUERY_PARAM_NAME} from './PagerNew.consts'

export function useCurrentPageState(): [number, (page: number) => void] {
  const [currentPage, setCurrentPage] = useQueryParamState(
    PAGE_QUERY_PARAM_NAME,
    String(DEFAULT_PAGE),
  )
  const changeCurrentPage = useCallback(
    (page: number) => setCurrentPage(String(page)),
    [setCurrentPage],
  )

  return [Number(currentPage), changeCurrentPage]
}
